// This file is generated by pnpm icons:generate. Do not edit.

import {createSVG} from '../TEMPLATE'

export const VerifiedCheck = createSVG({
  elements: [
    {
      fill: 'currentColor',
      stroke: 'none',
      type: 'path',
      d: 'M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25Zm4.28 8.03-5.25 5.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 1.06-1.06l1.72 1.72 4.72-4.72a.75.75 0 0 1 1.06 1.06Z',
      fillRule: 'evenodd',
    },
  ],
  viewBox: '0 0 24 24',
  glyph: 'VerifiedCheck',
})
